import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-764aef83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onspan" }
const _hoisted_2 = {
  key: 0,
  class: "mytext"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/compontsimg/ico_ts_red@2x.png",
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.text), 1)
        ], 64))
  ]))
}